import { useTranslation } from "react-i18next";
import { UsersPanelHeader } from "../../components/admin/UsersPanel/UsersPanelHeader";
import { useDispatch, useSelector } from "react-redux";
import {
  getUsersList,
  setApiInProgress,
} from "../../redux/slices/admin.slices/users.slice";
import { RootState } from "../../redux/store";
import { useEffect } from "react";
import { UserPanelItems } from "../../components/admin/UsersPanel/UserPanelItems";

export const UsersPanel = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { selectedCity } = useSelector((state: RootState) => state.city);
  const { items, apiInProgress } = useSelector(
    (state: RootState) => state.users
  );

  useEffect(() => {
    if (!items?.length && items?.length === 0 && !apiInProgress) {
      handleSearch("", false);
    }
  });

  const handleSearch = (searchID: string, searchActiveCity: boolean) => {
    dispatch(setApiInProgress(false));
    dispatch(
      getUsersList({
        city:
          searchActiveCity && selectedCity?.city !== "All Cities"
            ? selectedCity?.city
            : "",
        search: searchID,
      }) as any
    );
  };

  return (
    <div className="p-6 relative">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">{t("Users")}</h1>
        <UsersPanelHeader handleSearch={handleSearch} />
      </div>
      <div className="border-t border-primaryText/10 dark:border-primaryTextDark/10 mb-6" />
      {items?.length > 0 ? (
        <div className="mt-6 space-y-3">
          {items.map((user) => (
            <UserPanelItems user={user} />
          ))}
        </div>
      ) : (
        <div className="text-sm text-gray-500 text-center py-10">
          {t("No active users found")}
        </div>
      )}
    </div>
  );
};
